import { useEffect, useState } from 'react'
import style from '../Geral/geral.module.css'
import BackButton from '../../layout/BackButton'
import { useAuth } from '../../../hooks/AuthContext'
import { useToast } from '../../../hooks/Toast'
import { buscarRelatoriosRecebidos } from '../../../firebase/hierarquia'

function totalDoRelatorio(relatorio) {
  return (relatorio.progressao || []).reduce(
    (acc, g) => ({
      qtdAlunos: acc.qtdAlunos + (g.qtdAlunos || 0),
      qtdPresent: acc.qtdPresent + (g.qtdPresent || 0),
      qtdVisit: acc.qtdVisit + (g.qtdVisit || 0),
    }),
    { qtdAlunos: 0, qtdPresent: 0, qtdVisit: 0 },
  )
}

export default function RelatoriosRecebidos() {
  const { usuario } = useAuth()
  const { mostrarAviso } = useToast()

  const [papel, setPapel] = useState('regional') // 'regional' | 'geral'
  const [relatorios, setRelatorios] = useState([])
  const [carregando, setCarregando] = useState(true)

  useEffect(() => {
    if (!usuario?.idEscola) return
    setCarregando(true)
    buscarRelatoriosRecebidos(usuario.idEscola, papel)
      .then(setRelatorios)
      .catch((error) => mostrarAviso('Erro ao buscar relatórios: ' + error.message, 'erro'))
      .finally(() => setCarregando(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuario?.idEscola, papel])

  return (
    <section className={`${style.container}`}>
      <BackButton />
      <h3>Relatórios recebidos das escolas vinculadas</h3>

      <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginBottom: 16 }}>
        <button onClick={() => setPapel('regional')} disabled={papel === 'regional'}>
          Como Regional
        </button>
        <button onClick={() => setPapel('geral')} disabled={papel === 'geral'}>
          Como Geral
        </button>
      </div>

      {carregando && <p>Carregando...</p>}

      {!carregando && relatorios.length === 0 && (
        <p>Nenhum relatório recebido ainda como {papel === 'regional' ? 'Regional' : 'Geral'}.</p>
      )}

      {!carregando && relatorios.length > 0 && (
        <table className={`${style.tabela}`}>
          <thead>
            <tr>
              <th>Escola de origem</th>
              <th>Data</th>
              <th>Lição</th>
              <th>Matriculados</th>
              <th>Presentes</th>
              <th>Visitantes</th>
              <th>Ofertas</th>
            </tr>
          </thead>
          <tbody>
            {relatorios.map((r) => {
              const totais = totalDoRelatorio(r)
              return (
                <tr key={r.id}>
                  <td data-label="Escola de origem">{r.nomeEscolaOrigem || r.idEscolaOrigem}</td>
                  <td data-label="Data">
                    {r.data ? `${String(r.data.dia).padStart(2, '0')}/${String(r.data.mes).padStart(2, '0')}/${r.data.ano}` : '-'}
                  </td>
                  <td data-label="Lição">{r.licao}</td>
                  <td data-label="Matriculados">{totais.qtdAlunos}</td>
                  <td data-label="Presentes">{totais.qtdPresent}</td>
                  <td data-label="Visitantes">{totais.qtdVisit}</td>
                  <td data-label="Ofertas">{Number(r.ofertas || 0).toFixed(2)}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      )}
    </section>
  )
}
